import supplyVentilation_1 from '../../../images/components/Slider/gallery/supply-ventilation-1.jpeg';
import supplyVentilation_2 from '../../../images/components/Slider/gallery/supply-ventilation-2.jpeg';
import ductedAirConditioner_1 from '../../../images/components/Slider/gallery/ducted-air-conditioner-1.jpeg';
import ductedAirConditioner_2 from '../../../images/components/Slider/gallery/ducted-air-conditioner-2.jpeg';

const gallery = [
  {
    image: supplyVentilation_1,
    title: 'Приточная вентиляция',
    description: 'Монтаж приточной вентиляции (объект в Прайм Парк)',
  },
  {
    image: supplyVentilation_2,
    title: 'Приточная вентиляция',
    description: 'Монтаж приточной вентиляции (объект в ГУМ)',
  },
  {
    image: ductedAirConditioner_1,
    title: 'Канальные кондиционеры',
    description:
      'Монтаж канальных кондиционеров для скрытого охлаждения (объект в Вегас)',
  },
  {
    image: ductedAirConditioner_2,
    title: 'Канальные кондиционеры',
    description:
      'Инсталляция канальных систем кондиционирования воздуха (объект в Мега)',
  },
];

export default gallery;
